export default __webpack_public_path__ + "static/media/crifImage.120d9f10.png";